import gql from 'graphql-tag';

// TODO: yarn graphql:types static/bundles/enterprise-admin-account/utils/AdminDashboardGraphqlQuery.ts
export const enterpriseContractQuery = gql`
  query enterpriseContractQuery($id: String!) {
    DecoratedEnterpriseContractsV1Resource {
      byThirdPartyOrganization(id: $id) {
        elements {
          id
          name
          autoRenewInformation {
            ... on DecoratedEnterpriseContractsV1_org_coursera_product_enterprise_contract_decorated_AutoRenewInformation {
              renewAmount
              userLimit
              currencyCode
              renewsAt
              enterprisePromotionId
            }
          }
          contractTags {
            elements {
              id
              contractTag
            }
          }

          enterpriseContractId
          planId
          endsAt
          contractType
          billingType
          billingSystemType
          startsAt
          isRefunded
          amountRefunded
          refundDeadline
          value
          amountRemaining
          endedAt
          terminationReason
          terms {
            id
            endsAt
            termTag
          }
          limits {
            userLimit
            coursesPerUserLimit
          }
          remainingTermPayments {
            paymentDate
            amount
            currencyCode
          }
          value
          previousPayments {
            amount
            cartId
            currencyCode
            invoiceId
            transactionId
            paymentAt
            paymentType
            seatsAdded
            paymentInformation {
              paymentProcessorId
              creditCardLastFourDigits
              creditCardType
            }
          }
          contractState
          nextPaymentInformation {
            dueAt
            amount
            currencyCode
            isPaymentOverdue
            isPaymentDue
            willPaymentMethodExpireBeforePaymentDate
          }
          isPriceFluctuationPossible
          properties {
            ... on DecoratedEnterpriseContractsV1_selfServePropertiesMember {
              selfServeProperties {
                paymentWalletId
              }
            }
            ... on DecoratedEnterpriseContractsV1_invoiceBilledContractPropertiesMember {
              invoiceBilledContractProperties {
                userId
                customerId
                paymentProcessorId
              }
            }
          }
        }
      }
    }
  }
`;

export const singleEnterpriseContractQuery = gql`
  query SingleEnterpriseContractQuery($id: String!) {
    DecoratedEnterpriseContractsV1Resource {
      get(id: $id) {
        id
        autoRenewInformation {
          ... on DecoratedEnterpriseContractsV1_org_coursera_product_enterprise_contract_decorated_AutoRenewInformation {
            renewAmount
            userLimit
            currencyCode
            renewsAt
            enterprisePromotionId
          }
        }

        contractTags {
          elements {
            id
            contractTag
          }
        }

        enterpriseContractId
        planId
        endsAt
        billingType
        billingSystemType
        startsAt
        isRefunded
        amountRefunded
        refundDeadline
        value
        amountRemaining
        endedAt
        terminationReason
        terms {
          id
          endsAt
          startsAt
        }
        limits {
          userLimit
          coursesPerUserLimit
        }
        remainingTermPayments {
          paymentDate
          amount
          currencyCode
        }
        value
        previousPayments {
          amount
          cartId
          currencyCode
          invoiceId
          transactionId
          paymentAt
          paymentType
          seatsAdded
          paymentInformation {
            paymentProcessorId
            creditCardLastFourDigits
            creditCardType
          }
        }
        contractState
        nextPaymentInformation {
          dueAt
          amount
          currencyCode
          isPaymentOverdue
          isPaymentDue
          willPaymentMethodExpireBeforePaymentDate
        }
        countryIsoCode
        currencyCode
        isPriceFluctuationPossible
        utilization {
          id
          total
          remaining
        }
        properties {
          ... on DecoratedEnterpriseContractsV1_selfServePropertiesMember {
            selfServeProperties {
              paymentWalletId
            }
          }
          ... on DecoratedEnterpriseContractsV1_invoiceBilledContractPropertiesMember {
            invoiceBilledContractProperties {
              userId
              customerId
              paymentProcessorId
            }
          }
        }
      }
    }
  }
`;

// enterprisePaymentWalletId: `enterpriseContractId~paymentWalletId`
export const enterprisePaymentWalletQuery = gql`
  query enterprisePaymentWalletQuery($enterprisePaymentWalletId: String!) {
    EnterprisePaymentWalletsV1Resource {
      get(id: $enterprisePaymentWalletId) {
        id
        paymentProcessorId
        creditCardLastFourDigits
        creditCardType
        paymentWalletId
        creditCardExpiration
        billingCountry
        billingZipcode
        email
      }
    }
  }
`;

export const getInstallmentLicenseCountQuery = gql`
  query GetInstallmentLicenseCountQuery($contractId: String!, $termId: String!) {
    EnterpriseContractTransactionsV1Resource {
      findByContractIdAndMaybeTermId(contractId: $contractId, termId: $termId) {
        elements {
          id
          enterpriseContractTransactions {
            limitValuesUpdate {
              usersAdded
            }
          }
        }
      }
    }
  }
`;

export const EnterprisePromotionQuery = gql`
  query EnterprisePromotionQuery($enterprisePromotionId: String!) {
    EnterprisePromotionsV1Resource {
      get(id: $enterprisePromotionId) {
        id
        promotionId
        promotion {
          id
          promotionName
          discountPercent
        }
      }
    }
  }
`;
